import { Component, Inject, Input, forwardRef } from '@angular/core';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { FranchiseOwnerSettingsModel } from './typings/franchise.owner-settings';
import { FranchisesService }           from './franchises.service';
import { MessagesService }             from '../messages/messages.service';

@Component({
  selector   : 'wor-franchises-owner-settings',
  template: require('./franchises.owner-settings.component.html')
})
export class FranchisesOwnerSettingsComponent {
  @Input() settings: FranchiseOwnerSettingsModel;

  constructor (
    @Inject(forwardRef(() => FranchisesService)) private franchisesService: FranchisesService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  save ( form : NgForm ) : void {
    this.franchisesService.saveOwnerSettings(this.settings)
    .then(( settings : FranchiseOwnerSettingsModel ) => {
      this.settings = settings;

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');
    });
  }
}
